var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.trainTitle))]),
        _vm._v(" "),
        _vm._l(_vm.SessionsList, function(item, index) {
          return _c("div", { key: index, staticClass: "list" }, [
            _c("div", { staticClass: "list_title" }, [
              _vm._v(_vm._s(item.trainIndexDesc))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "list_attribute" }, [
              _c("div", { staticClass: "Training_date" }, [
                _vm._v("培训日期：" + _vm._s(item.trainDate))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "Training_time" },
                [
                  _vm._v("\n          培训时间："),
                  _vm._l(item.trainTimeList, function(i, s) {
                    return _c("span", { key: s }, [
                      _vm._v(_vm._s(i)),
                      s < item.trainTime.length - 1
                        ? _c("span", [_vm._v("，")])
                        : _vm._e()
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "Trainer" }, [
                _vm._v("培训讲师：" + _vm._s(item.teacherName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title_content" }, [
              _c("div", { staticClass: "title_content_text" }, [
                _vm._v(
                  "\n          培训内容：" +
                    _vm._s(_vm.trainContent) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            item.signStatus == "Yes"
              ? _c(
                  "div",
                  { staticClass: "list_button_stuta list_button_stuta1" },
                  [_vm._v("已签到")]
                )
              : _vm._e(),
            _vm._v(" "),
            item.signStatus == "noSignAlreadyOpen"
              ? _c(
                  "div",
                  {
                    staticClass: "list_button_stuta list_button_stuta2",
                    on: {
                      click: function($event) {
                        return _vm.GoSignin(item.seqId)
                      }
                    }
                  },
                  [_vm._v("点击签到")]
                )
              : _vm._e(),
            _vm._v(" "),
            item.signStatus == "noSignedNoOpen"
              ? _c(
                  "div",
                  {
                    staticClass: "list_button_stuta",
                    class:
                      item.signStatus == "noSignedNoOpen" &&
                      item.signStatus != "Yes"
                        ? "list_button_stuta4"
                        : "list_button_stuta3"
                  },
                  [_vm._v("点击签到")]
                )
              : _vm._e()
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aeb24eee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeb24eee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/Sessions.vue
// module id = 1652
// module chunks = 0